import React from 'react';
import '../App.css';
import Header from '../Components/Header'; // ✅ Import the Header component

const About = () => {
  return (
    <div className="about-page">
      {/* ✅ Use shared Header */}
      <Header />

      {/* About Us Main Section */}
      <section className="about-section">
        <div className="container">
          <h2>About Chaman Hospital</h2>
          <p>
            Chaman Hospital, located in the heart of Bahadurgarh, Patiala, has been a pillar of healthcare for the local community for over a decade. Our mission is to provide compassionate, accessible, and advanced medical care to everyone, regardless of background or financial condition.
          </p>
          <p>
            We pride ourselves on offering a wide range of specialties, cutting-edge diagnostic tools, emergency support, and government-backed healthcare schemes like the PMKVY card for free treatments.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-section">
        <div className="container">
          <div className="grid-two">
            <div>
              <h3>Our Mission</h3>
              <p>To deliver quality, affordable healthcare services with empathy and dedication, using modern technologies and the best clinical practices.</p>
            </div>
            <div>
              <h3>Our Vision</h3>
              <p>To become the most trusted hospital in Patiala district, setting a benchmark in patient care, innovation, and community service.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="container">
          <h2>Why Choose Chaman Hospital?</h2>
          <ul className="facilities-list">
            <li>✔ Experienced Doctors & Caring Staff</li>
            <li>✔ Advanced Equipment & Clean Environment</li>
            <li>✔ 24/7 Emergency & Ambulance Support</li>
            <li>✔ PMKVY Card Accepted – Free Government Treatments</li>
            <li>✔ Patient-Centric Philosophy</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      <section className="home-cta">
        <div className="container">
          <h2>Want to Know More?</h2>
          <p>Feel free to reach out or visit us. We’re always ready to assist you.</p>
          <a href="/contact" className="btn btn-primary">Contact Us</a>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital, Bahadurgarh – All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default About;
